var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"outerFrame"},[_c('router-view'),_c('el-footer',[_vm._v("Copyright © 2021 Forecast Inc. All Rights Reserved.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }